import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2db4a43a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-field", "value", "onClick"]
const _hoisted_2 = { class: "filter-item__box-text" }


import {useFiltersStore} from "@/store/SerpPage/FiltersStore";

export default /*#__PURE__*/_defineComponent({
  __name: 'BoxItem',
  props: ['filterDataValues', 'field'],
  emits: ['closeDropdown'],
  setup(__props, { emit }) {

const filtersStore = useFiltersStore();



function updateFilter(field: string, label:string) {
  filtersStore.updateFilter(field, label);
  emit('closeDropdown');
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filterDataValues, (filterData) => {
    return (_openBlock(), _createElementBlock("button", {
      key: filterData.label,
      class: "filter-item__box q-btn q-btn-outline-dark q-me-1 q-mb-1 q-p-1",
      "data-field": __props.field,
      value: filterData.label,
      onClick: ($event: any) => (updateFilter(__props.field, filterData.label))
    }, [
      _createElementVNode("small", _hoisted_2, _toDisplayString(filterData.label), 1)
    ], 8, _hoisted_1))
  }), 128))
}
}

})